import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { ExpenseService } from '../../../service/expense/expense.service';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { HeaderComponent } from '../../../../app/menu/header/header.component';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from 'app/util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { CarrierService } from '../../../service/carrier/carrier.service';

@Component({
  selector: 'app-root',
  templateUrl: 'wa8010.component.html',
  styleUrls: ['wa8010.component.scss']
})
export class Wa8010Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA8010:諸掛照会';
  public ownerchange;
  @ViewChild(HeaderComponent)
  private headerComponent: HeaderComponent;
  private isEnableClearFilterButton = false;

  @ViewChild('gridView')
  gridView: ElementRef;
  private tabIndex = 0;
  private originalRowData: any[];
  private isShowGridNoDataOverlay = false;
  private carrierService: CarrierService;

  private isShow8012 = false;
  private isShow8014 = false;
  private isShow8013 = false;

  public gridOptions: GridOptions;
  public gridOptions1_2: GridOptions;
  public showGrid: boolean;
  public rowData = [];

  public ownerId: number;
  public ownerResult: any;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  private errorInfo = '';

  private gridHelper1_1: AgGridHelper;
  private gridHelper1_2: AgGridHelper;
  private gridHelper2: AgGridHelper;

  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGetRowCount = 0;
  private isOwnerSearchNone = false;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;

  constructor(
    private router: Router,
    private expenseService: ExpenseService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private salesGroupOwnerService: SalesGroupOwnerService
  ) {
    this.gridHelper1_1 = new AgGridHelper();
    this.gridHelper1_1.scrollArrowCustomVarietyValue = -121;
    const rows = localStorage.getItem('wa8010_rowsPerPage_idx');
    this.gridOptions = <GridOptions>{
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      onColumnResized: this.saveColumnWidth,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa8010_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper1_1.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableClearFilterButton = this.gridOptions.api.isAnyFilterPresent();
        this.errorInfo = '';
        this.gridHelper1_1.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper1_1.renderScrollArrow();
        this.gridHelper1_1.renderGridCheckboxImage();
      },

      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper1_1.onRowDataChanged();
        /*
        Observable.timer(100).subscribe(() => {
          this.searchByKey();
        });*/
      },
      overlayLoadingTemplate: this.gridHelper1_1.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper1_1.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper1_1.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper1_1.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'col1',
        pinned: 'left',
        suppressMenu: true,
        width: 100,
        cellClass: ['tc', 'cellclass'],
        //suppressMovable: true,
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '修正',
          onClick: this.onEditButtonClick.bind(this)
        }
      },
      {
        headerName: '発生日',
        headerTooltip: '発生日',
        field: 'originalDt',
        width: this.getColumnWidth('originalDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主コード',
        headerTooltip: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        headerTooltip: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'コード',
        headerTooltip: 'コード',
        field: 'salesgroupCd',
        width: this.getColumnWidth('salesgroupCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '項目',
        headerTooltip: '項目',
        field: 'salesgroupTx',
        width: this.getColumnWidth('salesgroupTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '数量',
        headerTooltip: '数量',
        field: 'pcsNr',
        width: this.getColumnWidth('pcsNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '単位',
        headerTooltip: '単位',
        field: 'salesgroupunitTx',
        width: this.getColumnWidth('salesgroupunitTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単価',
        headerTooltip: '単価',
        field: 'unitpricedispNr',
        width: this.getColumnWidth('unitpricedispNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '税区分',
        headerTooltip: '税区分',
        field: 'typetaxTx',
        width: this.getColumnWidth('typetaxTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '金額',
        headerTooltip: '金額',
        field: 'pricedispNr',
        width: this.getColumnWidth('pricedispNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '備考',
        headerTooltip: '備考',
        field: 'expensememoTx',
        width: this.getColumnWidth('expensememoTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求対象外',
        headerTooltip: '請求対象外',
        field: 'notinvoiceTx',
        width: this.getColumnWidth('notinvoiceTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求対象外日時',
        headerTooltip: '請求対象外日時',
        field: 'notinvoiceDt',
        width: this.getColumnWidth('notinvoiceDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求対象外者名',
        headerTooltip: '請求対象外者名',
        field: 'notinvoiceuserTx',
        width: this.getColumnWidth('notinvoiceuserTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        headerTooltip: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        headerTooltip: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        headerTooltip: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 160),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        headerTooltip: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.gridHelper1_1.setGridOptions(this.gridOptions);
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa8010_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa8010_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa8010_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper1_1.el = this.gridView;
    setTimeout(() => {
      this.onSubmit();
    }, config.waitMsForSearchInNgAfterViewInit);
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  changeOwner(selectedOwnerId) {
    this.ownerchange = Math.ceil(Math.random() * 10);
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.originalRowData = [];
      this.gridOptions.api.deselectAll();
      this.filterGridByMoveType();
    }
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    this.expenseService
      .get(this.ownerId)
      .then(outputJson => {
        this.originalRowData = outputJson.expenses;
        this.filterGridByMoveType();
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  regallExpense() {
    this.isShow8013 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  updExpense() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    var data = this.gridOptions.api.getSelectedNodes()[0]['data'];
    if (data.commitFl === 1) {
      this.errorInfo = '確定した行は修正できません';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('rowExpense', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa8012']);
  }

  updallExpense() {
    this.errorInfo = '';
    this.working = true;
    if (!this.ownerId) {
      this.working = false;
      this.errorInfo = '荷主を選択して下さい';
      return;
    }
    if (this.originalRowData.length == 0) {
      this.working = false;
      this.errorInfo = '修正対象データがありません';
      return;
    }
    this.salesGroupOwnerService
      .get()
      .then(outputJson => {
        this.working = false;
        if (this.ownerId !== undefined && outputJson.salesgroupowners !== undefined) {
          var salesgroupowners = outputJson.salesgroupowners.filter((item, index) => {
            if (item.ownerId == this.ownerId) return true;
          });
        }
        let salesgroupownerObj = {};
        for (let i = 0; i < salesgroupowners.length; i++) {
          salesgroupownerObj[salesgroupowners[i].salesgroupId] = salesgroupowners[i].salesgroupTx;
        }
        sessionStorage.setItem('salesgroupownerObj', JSON.stringify(salesgroupownerObj));

        sessionStorage.setItem('wa8014_ownerId', String(this.ownerId));
        this.isShow8014 = true;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onEditButtonClick(node) {
    sessionStorage.setItem('rowExpense', JSON.stringify(node['data']));
    this.isShow8012 = true;
    sessionStorage.removeItem('isShowOwnerSelect');
  }

  onTabChanged(index) {
    this.tabIndex = index;
    this.filterGridByMoveType();
    this.errorInfo = '';
    this.gridOptions.api.deselectAll();
    this.toggleGridCheckbox();
  }

  toggleGridCheckbox() {
    this.gridOptions.columnApi.setColumnVisible('checkbox', this.tabIndex == 0 || this.tabIndex == 1);
    this.gridOptions.columnApi.setColumnVisible('col1', this.tabIndex == 0);
  }

  filterGridByMoveType() {
    var filterKeys = [];
    switch (this.tabIndex) {
      case 0:
        filterKeys.push('未確定');
        break;
      case 1:
        filterKeys.push('確定');
        break;
    }
    var bkgFilter = this.gridOptions.api.getFilterModel();
    this.gridOptions.api.setRowData([]);
    this.gridOptions.api.setFilterModel(bkgFilter);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    if (this.originalRowData == null || this.originalRowData.length == 0) return;

    var newRow1Datas = [];
    var newRow2Datas = [];
    this.originalRowData.forEach(data => {
      if (data.commitFl == 1) {
        newRow2Datas.push(data);
      } else {
        newRow1Datas.push(data);
      }
    });
    if (this.tabIndex == 0) {
      this.gridOptions.api.updateRowData({
        add: newRow1Datas
      });
    } else {
      this.gridOptions.api.updateRowData({
        add: newRow2Datas
      });
    }
  }

  onRowDataChanged() {
    this.errorInfo = '';
    let rowCount = this.gridOptions.api.getModel().getRowCount();
    if (rowCount > 0) this.isShowGridNoDataOverlay = false;
    else this.isShowGridNoDataOverlay = true;
  }

  onCloseWindow(isRefreshGrid: boolean) {
    this.isShow8012 = false;
    this.isShow8013 = false;
    if (isRefreshGrid) this.onSubmit();
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  onClose8014(isRefreshGrid: boolean) {
    this.isShow8014 = false;
    if (isRefreshGrid) this.onSubmit();
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper1_1.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    localStorage.setItem('wa8010_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa8Billing/wa8010/wa8010.component.ts